var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"slider-demo"}},[_c('slider-default'),_c('slider-color'),_c('slider-ticks'),_c('slider-range'),_c('slider-icon'),_c('slider-text-fixed'),_c('slider-change-method')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }